import IconCard from "components-lib/IconCard/IconCard";
import PageHeader from "components-lib/PageHeader/PageHeader";
import paths from "paths";
import React, { useState ,useEffect } from "react";
import { injectIntl } from "react-intl";
import { generatePath } from "react-router-dom";
import ClubTable from "./ClubTable";
import CLUBS_TABLE from 'queries/ClubsQueries/clubsTable';
import { useLocation } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import { useQuery } from '@apollo/client';
import { pathOr } from 'rambda';
import Loading from "components-lib/Loading/Loading";
import { connect } from 'react-redux';
import PROFILE from 'queries/ProfileQueries/profile';
import RoleEnum from 'common/enums/RoleEnum';
import { changePendingRequestsNumberAction } from 'redux/actions';
import { getApolloClient } from "configFiles/apollo";
import { useSnackbar } from "notistack";
import RequestStatusesEnum from 'common/enums/RequestStatusesEnum';
import RequestTypesEnum from 'common/enums/RequestTypesEnum';
import REQUESTS_TABLE from 'queries/RequestsQueries/requestsTable';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import { getUserToken } from "helpers/helpers";
import { getAPIUrl } from "configFiles/config";

const ClubListPage = (props) => {
  const { intl, history, role, changePendingRequestsNumberAction } = props;
  let location = useLocation();
  let defaultFilter = location.state ? location.state : null
  const { data: userProfile } = useQuery(PROFILE);
  const { enqueueSnackbar } = useSnackbar();
  const client = getApolloClient(enqueueSnackbar, history, intl);
  const [ edit, setEdit ] = React.useState(false);
  const [ disableButton, setDisableButton ] = useState(false);

  useEffect(() => {
    if (role === RoleEnum.STATUTORY || role === RoleEnum.PRESIDENT || role === RoleEnum.MEMBER) {
      if (pathOr('', ['me', 'member', 'club'], userProfile))
        history.push(`/admin${generatePath(paths.clubs.detail, { clubId: pathOr('', ['me', 'member', 'club', 'id'], userProfile) })}`)
    }
  }, [userProfile]);


  const getPendingRequestsNumber = async () => {
    try {
      const result = await client.query({
        query: REQUESTS_TABLE,
        variables: {
          "filter": [
            {
              "status": {
                "eq": (role === RoleEnum.ADMIN) ? RequestStatusesEnum.AWAITING : RequestStatusesEnum.RETURNED
              },
              "type": {
                "notIn": [RequestTypesEnum.CLUB_TRANSFER, RequestTypesEnum.CLUB_HOSTING]
              },
            }
          ]
        }
      });
      if (result.error) {
        throw result.error;
      }
      if (result.errors) {
        throw result.errors[0];
      }
      changePendingRequestsNumberAction(pathOr('', ['data', 'requestsTable', 'totalCount'], result))
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    if (role === RoleEnum.STATUTORY)
    getPendingRequestsNumber()
  }, []);

  const handleGetExportClubs = async () => {
    let url = `${getAPIUrl('rest')}/export/clubs`
    const result = await fetch(url, {
      headers: {
        authorization: `Bearer ${(getUserToken() || "")}`,
      }
    })
    const blob = await result.blob()
    const href = window.URL.createObjectURL(blob)

    var downloadLink = document.createElement("a");
    downloadLink.href = href;
    downloadLink.download = `${intl.formatMessage({ id: 'club.clubsExport.file' })}.xlsx`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }


  const getActions = () => {
    return [
      {
        title: intl.formatMessage({ id: "club.new.button" }),
        icon: <AddIcon />,
        onClick: () => history.push(`/admin${generatePath(paths.clubs.new)}`),
      },
      {
        title: intl.formatMessage({ id: "club.edit.button" }),
        // icon: <AddIcon />,
        onClick: () => {
          setEdit(true);
          setDisableButton(true)
        },
        disabled: disableButton
      },
      {
        title: intl.formatMessage({ id: 'club.clubsExport' }),
        icon: <SystemUpdateAltIcon />,
        onClick: () => handleGetExportClubs(),
      }
    ];
  };

  return (
    <div
    className= 'clubsTableContainer'
      style={{
        width: 'auto',
        maxWidth: '115rem',
      }}
    >
      <PageHeader
        title={null}
        // headerWidth="100%"
        actions={getActions()}
        withBackButton={false}
      />
      <IconCard>
        <ClubTable
          query={CLUBS_TABLE}
          defaultFilter={defaultFilter}
          history={history}
          queryDataPath={['clubsTable', 'items']}
          edit={edit}
          setEdit={setEdit}
          setDisableButton={setDisableButton}
        />
      </IconCard>
    </div>
  );
};

const mapStateToProps = (state) => ({
  role: state.role,
});

const mapDispatchToProps = (dispatch) => ({
  changePendingRequestsNumberAction: (value) => dispatch(changePendingRequestsNumberAction(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ClubListPage));